<template>
    <div class="card" v-for="{title, date, activities}, i in items" :key="i">
        <h1 class="card-title inter-500 linear-gradient-black-to-green-2">{{ title }}</h1>
        <h3 class="card-subtitle source-code-pro-300">{{ date }}</h3>
        <ul class="list" v-for="activity, i in activities" :key="i">
            <li class="source-code-pro-400">{{ activity }}</li>
        </ul>
    </div>
</template>

<script setup lang="ts">

import { Experience } from '@/interfaces/experience.interface';
import { ref } from 'vue';

    const props = defineProps<{
        value: Experience[]
    }>()
    const items = ref(props.value)
</script>

<style scoped>
.card{
    padding: 0.5em 2em;
    
}

.card-title, .card-subtitle, .list {
    margin-bottom: 0.5rem;
}
</style>